import { createReducer } from '@reduxjs/toolkit'
import {
  clientSettingsReducerConfig,
  initialClientSettingsState,
} from '@gocanvas/client/dist/store/reducers/clientSettings/index.jsx'

const fetchClientSetting = setting => {
  const clientSettings = window.configAttachment || {}
  return clientSettings[setting]
}

export const initialState =   {
  ...initialClientSettingsState,
  interactiveClient: true,
  fileSizeLimit: fetchClientSetting("file_size_limit") ? fetchClientSetting("file_size_limit") : initialClientSettingsState.fileSizeLimit,
  clientType: 'builder',
  prePopulationLimit: 150,
  undoEnabled: true,
}

export const clientSettingsReducer = createReducer(
  initialState,
  clientSettingsReducerConfig
)
